// EventCalendarFilters.tsx
import * as React from "react";
import CalendarPicker from "../../../ReactComponents/CalendarPicker/CalendarPicker";
import { SelectItemViewModel } from "./SelectItemViewModel.csharp";
import { EventCalendarTranslations } from "./EventCalendarTranslations.csharp";
import { CalendarLocalization } from "../../../ReactComponents/CalendarPicker/CalendarLocalization.csharp";
import Dropdown, { Option } from "react-dropdown";

export interface EventCalendarFiltersProps {
    translations: EventCalendarTranslations;
    currentCategory: string;
    onCategoryChange: (arg: Option) => void;
    isLoading: boolean;
    categories: SelectItemViewModel[];
    currentDate: Date | null;
    currentEndDate?: Date | null;
    onDateChange: (date: Date) => void;
    localization: CalendarLocalization;
    totalResults?: number;
    isSearching?: boolean;
    categoryLabel?: string;
    onRangeChange?: (range: { from: Date | undefined; to: Date | undefined }) => void;
    onClearFilters: () => void;
}

export const defaultSelectValue = "all";

export const EventCalendarFilters = (props: EventCalendarFiltersProps) => {
    const sortedCategories = props.categories.sort((a, b) => a.sortOrder - b.sortOrder);
    const categories = [{ value: defaultSelectValue, label: props.translations.showAllEvents }, ...sortedCategories];

    const handleResult = () => {
        let result = "";

        if (props.localization.cultureName === "en") {
            // For English
            if (props.isSearching) {
                // When searching/filtering: "Found X events" or "Found X events in Category"
                result += props.translations.totalResults + " " + props.totalResults + " ";

                if (props.totalResults === 1) {
                    result += "event";
                } else {
                    result += "events";
                }

                if (props.currentCategory !== "all" && props.categoryLabel) {
                    result += " in " + props.categoryLabel;
                }
            } else {
                // When showing all (no filters): "X events"
                result += props.totalResults + " " + props.translations.events.toLowerCase();
            }
        } else {
            // For Norwegian
            if (props.isSearching) {
                // When searching/filtering: "Fant X arrangement" or "Fant X arrangement i Category"
                result += props.translations.totalResults + " " + props.totalResults + " ";

                if (props.totalResults === 1) {
                    result += "arrangement";
                } else {
                    result += "arrangement";
                }

                if (props.currentCategory !== "all" && props.categoryLabel) {
                    result += " i " + props.categoryLabel;
                }
            } else {
                // When showing all (no filters): "X arrangement"
                result += props.totalResults + " " + props.translations.events.toLowerCase();
            }
        }

        return result;
    };

    return (
        <div className="EventCalendarFilters">
            <div className="EventCalendar__inner">
                <fieldset className="EventCalendar__control">
                    <div className="EventCalendar__filter">
                        <Dropdown
                            options={categories}
                            onChange={props.onCategoryChange}
                            disabled={props.isLoading}
                            value={props.currentCategory}
                            placeholder={props.translations.categoryFilterPlaceholder}
                        />
                    </div>
                </fieldset>
                <fieldset className="EventCalendar__control">
                    <label htmlFor="calendar">{props.translations.dateLabel}</label>
                    <CalendarPicker
                        selectedValue={props.currentDate}
                        selectedEndValue={props.currentEndDate}
                        onDateChange={props.onDateChange}
                        disabled={props.isLoading}
                        localization={props.localization}
                        dateInputPlaceholder={props.translations.chooseDate}
                        onRangeChange={props.onRangeChange}
                    />
                </fieldset>
                <div className="EventCalendar__clear-button-container">
                    <button onClick={props.onClearFilters} className="EventCalendar__clear-button">
                        {props.translations.clearFilters}
                    </button>
                </div>
            </div>
            <div className="EventCalendar__results">
                <div>{handleResult()}</div>
            </div>
        </div>
    );
};
